const windFireWheelList = () => import('@/pages/windFireWheel/index')
const findVehicle = () => import('@/pages/windFireWheel/findVehicle')
const stationVehicle = () => import('@/pages/windFireWheel/stationVehicle')
const tireBindingDetail = () => import('@/pages/windFireWheel/tireBindingDetail')
const tireBindingPage = () => import('@/pages/windFireWheel/tireBindingPage')
const unbindReplacePage = () => import('@/pages/windFireWheel/unbindReplacePage')
export default [
  {
    path: '/windFireWheelList',
    name: 'windFireWheelList',
    component: windFireWheelList,
    meta: {
      storeKey: 'trs.tyre.index'
    }
  },
  {
    path: '/findVehicle',
    name: 'findVehicle',
    component: findVehicle,
    meta: {}
  },
  {
    path: '/stationVehicle',
    name: 'stationVehicle',
    component: stationVehicle,
    meta: {}
  },
  {
    path: '/tireBindingDetail',
    name: 'tireBindingDetail',
    component: tireBindingDetail,
    meta: {}
  },
  {
    path: '/tireBindingPage',
    name: 'tireBindingPage',
    component: tireBindingPage,
    meta: {}
  },
  {
    path: '/unbindReplacePage',
    name: 'unbindReplacePage',
    component: unbindReplacePage,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/windFireWheel/index.js